import { onMounted, onUnmounted, ref } from 'vue';
import store from '@/app/store';

export default function useScreenResolutionResizeTablet() {
	const isTablet = ref(false);

	function setTablet() {
		if (window.matchMedia('(max-width: 990px)').matches) {
			isTablet.value = true;
			store.commit('isTablet/setTablet', isTablet.value);
			// store.commit('mobileNav/showMobileNav');
		} else {
			isTablet.value = false;
			store.commit('isTablet/setTablet', isTablet.value);
		}

		if (window.matchMedia('(min-width: 991px)').matches) {
			store.commit('mobileNav/hideMobileNav');
			document.body.style.overflow = 'auto';
		}
	}

	onMounted(() => {
		window.addEventListener('resize', setTablet);
		setTablet();
	});

	onUnmounted(() => {
		window.removeEventListener('resize', setTablet);
	});

	return { isTablet };
}
